import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["field", "chip"]

  remove() {
    this.fieldTarget.value = ""
    this.chipTarget.remove()
  }
}
